var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("article", { staticClass: "wkb-sig-chain-pathway" }, [
    _c("header", { staticClass: "wkb-sig-chain-pathway-head" }, [
      _c("h3", { staticClass: "wkb-sig-chain-pathway-title" }, [
        _vm._v(_vm._s(_vm.chain.title || "Connection")),
      ]),
      _vm.chain.claim
        ? _c("p", { staticClass: "wkb-sig-chain-pathway-claim" }, [
            _vm._v(_vm._s(_vm.chain.claim)),
          ])
        : _vm._e(),
      _vm.chain.factor_label
        ? _c("p", { staticClass: "wkb-sig-chain-pathway-meta" }, [
            _c("strong", [_vm._v("Mechanism:")]),
            _vm._v(" " + _vm._s(_vm.chain.factor_label) + " "),
            _vm.chain.factor_id
              ? _c("code", [_vm._v(_vm._s(_vm.chain.factor_id))])
              : _vm._e(),
          ])
        : _vm._e(),
    ]),
    _c("section", { staticClass: "wkb-sig-chain-graph-panel" }, [
      _c("div", { staticClass: "wkb-sig-chain-graph-head" }, [
        _c("h4", { staticClass: "wkb-sig-chain-section-title" }, [
          _vm._v("How these nodes connect"),
        ]),
        _vm.packet
          ? _c("div", { staticClass: "wkb-sig-chain-zoom-controls" }, [
              _c(
                "button",
                {
                  staticClass: "wkb-sig-chain-zoom-btn",
                  attrs: {
                    type: "button",
                    title: "Zoom out",
                    "aria-label": "Zoom out",
                    disabled: _vm.pathwayZoomLevel <= _vm.pathwayZoomMin,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.adjustPathwayZoom(-_vm.pathwayZoomStep)
                    },
                  },
                },
                [_vm._v(" − ")]
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.pathwayZoomLevel,
                    expression: "pathwayZoomLevel",
                    modifiers: { number: true },
                  },
                ],
                staticClass: "wkb-sig-chain-zoom-slider",
                attrs: {
                  type: "range",
                  min: _vm.pathwayZoomMin,
                  max: _vm.pathwayZoomMax,
                  step: _vm.pathwayZoomStep,
                  "aria-label": "Connection graph zoom",
                },
                domProps: { value: _vm.pathwayZoomLevel },
                on: {
                  __r: function ($event) {
                    _vm.pathwayZoomLevel = _vm._n($event.target.value)
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
              _c(
                "button",
                {
                  staticClass: "wkb-sig-chain-zoom-btn",
                  attrs: {
                    type: "button",
                    title: "Zoom in",
                    "aria-label": "Zoom in",
                    disabled: _vm.pathwayZoomLevel >= _vm.pathwayZoomMax,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.adjustPathwayZoom(_vm.pathwayZoomStep)
                    },
                  },
                },
                [_vm._v(" + ")]
              ),
            ])
          : _vm._e(),
      ]),
      _c(
        "div",
        { staticClass: "wkb-sig-chain-graph-shell" },
        [
          _vm.loading
            ? _c(
                "div",
                {
                  staticClass: "wkb-sig-chain-graph-loading",
                  attrs: { role: "status" },
                },
                [
                  _c("span", {
                    staticClass: "wkb-sig-chain-spinner",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _c("strong", [_vm._v("Loading connection graph…")]),
                ]
              )
            : _vm.packet
            ? _c("WorkspaceTreeGraphCanvas", {
                attrs: {
                  "graph-nodes": _vm.packetGraphNodes,
                  "graph-edges": _vm.packetGraphEdges,
                  "contextual-edges": [],
                  "key-node-ids": _vm.selectedNodeIds,
                  "zoom-level": _vm.pathwayZoomLevel,
                  "hide-contextual-edges": true,
                  "hide-jumping-edges": true,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.error
        ? _c(
            "p",
            { staticClass: "wkb-sig-chain-error", attrs: { role: "alert" } },
            [_vm._v(_vm._s(_vm.error))]
          )
        : _vm._e(),
    ]),
    _c("div", { staticClass: "wkb-sig-chain-pathway-actions" }, [
      _vm.llmAvailable
        ? _c(
            "button",
            {
              staticClass: "wkb-sig-chain-btn wkb-sig-chain-btn-primary",
              attrs: {
                type: "button",
                disabled: !_vm.packet || _vm.hypothesisLoading,
              },
              on: { click: _vm.onGenerateHypothesisClick },
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.hypothesisEntry?.interpretation &&
                      !_vm.hypothesisLoading
                      ? "Regenerate hypothesis"
                      : "Generate hypothesis"
                  ) +
                  " "
              ),
            ]
          )
        : _vm.packet
        ? _c(
            "p",
            { staticClass: "wkb-sig-chain-llm-note", attrs: { role: "note" } },
            [_vm._v(" LLM explanations are not available for this session. ")]
          )
        : _vm._e(),
    ]),
    _vm.hypothesisLoading ||
    _vm.hypothesisEntry?.interpretation ||
    _vm.hypothesisEntry?.status === "error"
      ? _c(
          "section",
          { staticClass: "wkb-sig-chain-hypothesis" },
          [
            _c("h4", { staticClass: "wkb-sig-chain-section-title" }, [
              _vm._v("Hypothesis"),
            ]),
            _vm.hypothesisLoading
              ? _c(
                  "div",
                  {
                    staticClass: "wkb-sig-chain-loading",
                    attrs: { role: "status" },
                  },
                  [
                    _c("span", {
                      staticClass: "wkb-sig-chain-spinner",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._m(0),
                  ]
                )
              : _vm.hypothesisEntry?.status === "error"
              ? _c("p", { staticClass: "wkb-sig-chain-error" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.hypothesisEntry.error ||
                          "Hypothesis generation failed."
                      ) +
                      " "
                  ),
                ])
              : _vm.hypothesisEntry?.interpretation
              ? _c("WorkspaceMarkdownBlock", {
                  attrs: { text: _vm.hypothesisEntry.interpretation },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
    _vm.packet
      ? _c("details", { staticClass: "wkb-sig-chain-evidence" }, [
          _c("summary", { staticClass: "wkb-sig-chain-evidence-summary" }, [
            _vm._v("Association scores"),
          ]),
          _c("div", { staticClass: "wkb-sig-chain-evidence-body" }, [
            _c("section", { staticClass: "wkb-sig-chain-matrices" }, [
              _c("div", { staticClass: "wkb-sig-chain-ledger" }, [
                _c("div", { staticClass: "wkb-sig-chain-toolbar" }, [
                  _c(
                    "div",
                    {
                      staticClass: "wkb-sig-chain-tabs",
                      attrs: {
                        role: "tablist",
                        "aria-label": "Association score tables",
                      },
                    },
                    _vm._l(_vm.matrixTabs, function (tab) {
                      return _c(
                        "button",
                        {
                          key: tab.id,
                          staticClass: "wkb-sig-chain-tab",
                          class: {
                            "is-active": _vm.activeMatrixTab === tab.id,
                          },
                          attrs: {
                            id: _vm.matrixTabId(tab.id),
                            type: "button",
                            role: "tab",
                            "aria-selected":
                              _vm.activeMatrixTab === tab.id ? "true" : "false",
                            "aria-controls": _vm.matrixPanelId,
                          },
                          on: {
                            click: function ($event) {
                              _vm.activeMatrixTab = tab.id
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(tab.label) + " ")]
                      )
                    }),
                    0
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "wkb-sig-chain-panel",
                    attrs: {
                      id: _vm.matrixPanelId,
                      role: "tabpanel",
                      "aria-labelledby": _vm.matrixTabId(_vm.activeMatrixTab),
                    },
                  },
                  [
                    _c("WorkspaceSigChainMatrix", {
                      attrs: {
                        matrix: _vm.activeMatrix,
                        "active-cell-key": _vm.activeCellKey,
                      },
                      on: { "cell-click": _vm.onMatrixCellClick },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _vm.selectedEdgeSummary
              ? _c("section", { staticClass: "wkb-sig-chain-edge-note" }, [
                  _c("h4", { staticClass: "wkb-sig-chain-section-title" }, [
                    _vm._v("Selected edge"),
                  ]),
                  _c("p", { staticClass: "wkb-sig-chain-edge-line" }, [
                    _vm._v(" " + _vm._s(_vm.selectedEdgeSummary) + " "),
                  ]),
                ])
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [_c("strong", [_vm._v("Generating hypothesis…")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }